<template>
  <pt-holiday-table class="pt-holiday-table__withData" @getTableData="getTableData" :tableData="tableData" :totalNumber="totalNumber"
  ref="tableIndex" :isOutside="isOutside" v-on="$listeners">
    <slot/>
  </pt-holiday-table>
</template>

<script>
import PtHolidayTable from './index'
export default {
  name: 'pt-holiday-table__withData',
  components: {
    'pt-holiday-table': PtHolidayTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 31 // 一月最多31天
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  computed: {
    page () {
      return this.$refs.tableIndex.page
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
        //   this.getTableData(0)
          this.$refs.tableIndex.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    },
    tableData (val, old) {
      if (val !== old) {
        this.$emit('updateTableData', val)
      }
    }
  },
  methods: {
    getTableData (page, next) {
      /* global _ */
      if (this.paramsData.holidayTypes && _.isString(this.paramsData.holidayTypes)) {
        this.paramsData.holidayTypes = [this.paramsData.holidayTypes]
      }
      let data = {
        ...this.paramsData,
        pageableParam: {
          page: page,
          size: this.pageSize
        }
      }
      let api
      console.log('this.$route', this.$route)
      switch (this.$route.meta.type) {
        case 'gene':
          api = 'getHolidays'
          break
        case 'sign':
          api = 'getHolidayOfSign'
          break
        default:
          api = 'getAdultHolidays'
          break
      }
      // let api = this.$route.meta.type === 'gene' ? 'getHolidays' : 'getAdultHolidays'
      this.$store.dispatch(api, data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        console.log(this.tableData)
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$refs.tableIndex.showReTry()
        this.$message.error(err || '获取列表失败')
      })
    },
    load () {
      // this.$nextTick(_ => {
      this.$refs.tableIndex.load()
      // })
    }
  }
}
</script>
